import { Body } from './typography';

type ErrorMessageProps = {
  error: Error;
  message?: string;
};

/**
 * Inline error message. Renders a generic error message in error tone.
 * Use when an async operation fails and the page can still render.
 * The actual error is logged to console for debugging.
 */
export function ErrorMessage({ error, message }: ErrorMessageProps) {
  console.error(error);
  return (
    <Body tone="error">
      {message ?? 'Er ging iets mis bij het laden van de gegevens. Probeer het later opnieuw.'}
    </Body>
  );
}

export type { ErrorMessageProps };
